import type { Config, tAPI } from "./API";
import Storage from "./Storage";
// API Company static class

const apiBaseCompany = "/companies";
export default class Company {
  // Get a company for that companyId
  static GetCompany(api: tAPI, companyId: string, config?: Config) {
    return api.GET(`${apiBaseCompany}/${companyId}`, config);
  }
  // Edit a company from companyId
  static EditCompany(
    api: tAPI,
    companyId: string,
    data: object,
    _isUpload: boolean = false,
    config?: Config
  ) {
    return api.PATCH(`${apiBaseCompany}/${companyId}`, data, config);
  }
  // Get a Company files for that companyId
  static GetCompanyFiles(api: tAPI, companyId: string, config?: Config) {
    return Storage.ListFiles(api, "Companies", companyId, undefined, config);
  }
  // Get all Company files expired
  static GetCompanyFilesExpired(api: tAPI, config?: Config) {
    return Storage.ListFiles(
      api,
      "Companies",
      undefined,
      { aboutExpire: true },
      config
    );
  }
}
